// WelcomeSection.js - Advanced Modern Design
import React, { useState, useEffect, useRef } from "react";
import side_image from "../../Assets/transparent-gif-1.gif";
import "./WelcomeSection.css";
import { Link } from "react-router-dom";

const WelcomeSection = ({ homeData }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="nova-welcome" ref={sectionRef}>
      {/* Advanced Background Effects */}
      <div className="nova-bg-effects">
        <div className="nova-bg-glow glow-1"></div>
        <div className="nova-bg-glow glow-2"></div>
        <div className="nova-bg-glow glow-3"></div>
      </div>

      {/* Ambient Particles */}
      <div className="nova-ambient-sparks"></div>
      
      {/* Floating Particles - New */}
      <div className="nova-floating-particles">
        {[...Array(12)].map((_, i) => (
          <span key={i} className={`nova-float-particle particle-${i + 1}`}></span>
        ))}
      </div>

      <div className="nova-container">
        {/* LEFT: Visual Zone - Enhanced */}
        <div className={`nova-visual-zone ${isVisible ? 'animate-in' : ''}`}>
          <div className="nova-glow-core"></div>
          <div className="nova-visual-frame">
            <div className="nova-image-orb">
              <img 
                src={side_image} 
                alt="Fireworks Display" 
                className="nova-firework-gif"
              />
              <div className="nova-lens-flare"></div>
              <div className="nova-image-overlay"></div>
            </div>
            
            {/* Enhanced Kinetic Rings */}
            <div className="nova-ring nova-ring-1"></div>
            <div className="nova-ring nova-ring-2"></div>
            <div className="nova-ring nova-ring-3"></div>
            <div className="nova-ring nova-ring-4"></div>
            
            {/* Sparkles - More and Enhanced */}
            {[...Array(8)].map((_, i) => (
              <div key={i} className={`nova-sparkle sparkle-${i + 1}`}></div>
            ))}
          </div>
        </div>

        {/* RIGHT: Content - Enhanced */}
        <div className={`nova-content-zone ${isVisible ? 'animate-in' : ''}`}>
          {/* Badge Group - Premium */}
          <div className="nova-badge-group">
            <span className="nova-badge-glow">
              <span className="badge-icon">✦</span>
              DIWALI SPECIAL {new Date().getFullYear()}
              <span className="badge-icon">✦</span>
            </span>
            <div className="nova-pulse-dot">
              <span className="dot-ring"></span>
            </div>
            <span className="nova-live-badge">LIVE</span>
          </div>
          
          {/* Title - Single Row with Optimized Font Size */}
          <div className="nova-title-block">
            <p className="nova-intro-text">
              <span className="intro-line"></span>
              Illuminating Traditions Since 2012
              <span className="intro-line"></span>
            </p>
            <h1 className="nova-main-headline">
              <span className="nova-word-slide">Experience</span>
              <span className="nova-gradient-text"> Sri Madhan Traders</span>
            </h1>
            <div className="nova-fuse-line">
              <span className="fuse-spark"></span>
            </div>
          </div>

          {/* Description Card - Enhanced */}
          <div className="nova-description-card">
            <div className="nova-card-shine"></div>
            <div className="nova-card-border-glow"></div>
            <div className="nova-quote-mark">“</div>
            <div 
              className="nova-description-text" 
              dangerouslySetInnerHTML={{ __html: homeData?.value || "<p>Bringing the safest, brightest, and most spectacular fireworks to your celebrations. Trusted by thousands for premium quality and unmatched festive joy.</p>" }} 
            />
            <div className="nova-card-footer">
              <span className="card-tag">✦ Premium Quality</span>
              <span className="card-tag">✦ ISO Certified</span>
            </div>
          </div>

          {/* Feature Grid - Enhanced */}
          <div className="nova-feature-grid">
            <div className="nova-feature-pill">
              <div className="nova-pill-icon">🏆</div>
              <span>ISO Certified Quality</span>
              <div className="nova-pill-beam"></div>
              <div className="nova-pill-glow"></div>
            </div>
            <div className="nova-feature-pill">
              <div className="nova-pill-icon">🚚</div>
              <span>Express Pan-India</span>
              <div className="nova-pill-beam"></div>
              <div className="nova-pill-glow"></div>
            </div>
            <div className="nova-feature-pill">
              <div className="nova-pill-icon">💎</div>
              <span>Factory Direct Prices</span>
              <div className="nova-pill-beam"></div>
              <div className="nova-pill-glow"></div>
            </div>
          </div>

          {/* Action Row - Enhanced */}
          <div className="nova-action-row">
            <Link to="/" className="nova-primary-btn">
              <span className="btn-text">Explore Collection</span>
              <span className="btn-icon-wrapper">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </span>
              <span className="btn-ripple-effect"></span>
            </Link>
            <div className="nova-trust-badge">
              <div className="nova-stars">
                <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
              </div>
              <span className="trust-count">20k+ Happy Clients</span>
              <span className="trust-sub">★★★★★ 4.9/5 Rating</span>
            </div>
          </div>
        </div>
      </div>

      <div className="nova-ground-glow"></div>
    </div>
  );
};

export default WelcomeSection;